<template>
    <ButtonLink :ariaLabel="t({ key: 'shared.about_fees' })" :onClick="toggleModal">
        {{ label }}
    </ButtonLink>

    <Modal
        v-if="modal"
        :title="t({ key: 'shared.about_fees' })"
        :onClose="toggleModal"
        :lockBody="false"
        size="s">
        <div class="transfer-fees">
            <ul v-if="rows.length">
                <li v-for="(row, index) in rows" :key="index">{{ row }}</li>
            </ul>

            <ButtonPrimary :onClick="toggleModal">
                {{ t({ key: 'shared.close' }) }}
            </ButtonPrimary>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { defineComponent, ref, PropType, computed } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { TransferOption } from '@/api/Transfer/transfer.interfaces';
    import { logStatsigCheckoutTransferInteraction } from '@/tracking/statsig/checkout.functions';
    import Modal from '@ui/components/Modal/Modal.vue';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';

    export default defineComponent({
        name: 'Fees',
        methods: { t },
        components: { Modal, ButtonPrimary, ButtonLink },
        props: {
            option: { type: Object as PropType<TransferOption>, required: true },
        },
        setup({ option }) {
            const modal = ref<boolean>(false);

            function toggleModal() {
                modal.value = !modal.value;

                if (modal.value) {
                    logStatsigCheckoutTransferInteraction('Fees', option, null);
                }
            }

            const label = computed<string>(() => {
                const fullCovered = option.TollsIncluded && option.GratuityIncluded;

                if (fullCovered) {
                    return t({
                        key: 'shared.fees_included',
                    });
                } else {
                    return t({
                        key: 'shared.fees_may_apply',
                    });
                }
            });

            const rows = computed<string[]>(() => {
                return [
                    t({
                        key: option.GratuityIncluded
                            ? 'shared.tips_included_in_price'
                            : 'shared.tips_not_included_in_price',
                    }),
                    t({
                        key: option.TollsIncluded
                            ? 'shared.toll_fees_included_in_price'
                            : 'shared.toll_fees_not_included_in_price',
                    }),
                ];
            });

            return {
                label,
                modal,
                toggleModal,
                rows,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Fees.scss';
</style>
